// removed by extract-text-webpack-plugin
module.exports = {"people-results-container":"PeopleResults__people-results-container___dzm53"};